// Only used for getters that require logic
// Use ...mapState([]) for dummy getters!
// export const selectedOption = (state, objectName) => state[objectName];

import {
  sizeOptionData
} from '@/helpers/transform'

export const computedOptions = (state) => {
  let optionGroups = state.allOptionGroups
  optionGroups = optionGroups.map(optionGroup => {
    if (optionGroup.isSize) {
      let options = optionGroup.options.map(option => {
        option.optionData = sizeOptionData(option.optionCode)
        return option
      })
      optionGroup.options = options
      return optionGroup
    } else {
      return optionGroup
    }
  })
  return optionGroups
}
